module.exports = __webpack_public_path__ + "static/media/undraw_window_shopping_b96y.b4bec7a1.svg";